import { z } from 'zod';
import { Geometry, geometrySchema } from 'app/agriculture/queries/types/geometry/Geometry';
import { Position, positionSchema } from './Position';

export interface PointGeometry extends Geometry<'Point'> {
    coordinates: Position;
}

export const pointGeometrySchema = geometrySchema.extend({
    type: z.literal('Point'),
    coordinates: positionSchema,
});

export const mockPointGeometry = ({
    type = 'Point',
    coordinates = [0, 0],
}: Partial<PointGeometry> = {}): PointGeometry => ({
    type,
    coordinates,
});
